import { GEO_DATA } from 'src/dataLayer/env';
import { GEO_GROUPING, FLOW_NAME_BY_GEO } from 'src/dataLayer/localData/geoConfig';

export const getGeoFlowId = (flowId: string): string | undefined => {
  const flowGeoConfig = FLOW_NAME_BY_GEO[flowId];
  const { countryCode3 } = GEO_DATA;

  if (!flowGeoConfig) return flowId;

  let geoFlowId = flowGeoConfig[countryCode3];

  if (!geoFlowId) {
    for (const [geoGroup, geos] of Object.entries(GEO_GROUPING)) {
      if (geos.includes(countryCode3)) geoFlowId = flowGeoConfig[geoGroup];
    };
  };

  return geoFlowId || flowId;
};
